import { ReleaseNoteSectionViewOf } from 'bff';
import { cn } from 'ui';
import {
  editorialBody,
  editorialParagraph,
  editorialSubhead,
} from '../editorial';
import { RichText } from '../RichText';

export const ReleaseNoteSubhead = ({ children }: { children: string }) => (
  <h3
    className={cn(
      editorialSubhead,
      'mb-[0.5em] mt-[1.6em] text-[1.3125rem] md:text-2xl',
    )}
  >
    {children}
  </h3>
);

// A sub-chapter inside an item, e.g. the two halves of a long novelty.
export const HeadingSection = ({
  section: { content },
}: {
  section: ReleaseNoteSectionViewOf<'heading'>;
}) => (
  <>
    <ReleaseNoteSubhead>{content.title}</ReleaseNoteSubhead>
    {content.lead && (
      <div className={editorialBody}>
        <RichText text={content.lead} className={editorialParagraph} />
      </div>
    )}
  </>
);
